// ===========================================
// MAIN - smooth scroll for on-page anchor links
// (mobile menu lives in mobile-menu.js)
// ===========================================

document.addEventListener("click", function (event) {
  const link = event.target.closest('a[href*="#"]:not([href="#"]):not([href="#0"])');

  if (
    !link ||
    link.hostname !== location.hostname ||
    link.pathname.replace(/^\//, "") !== location.pathname.replace(/^\//, "")
  ) {
    return;
  }

  const hash = decodeURIComponent(link.hash.slice(1));
  const target =
    document.getElementById(hash) || document.querySelector(`[name="${CSS.escape(hash)}"]`);

  if (!target) {
    return;
  }

  event.preventDefault();

  if (window.smeLenis) {
    window.smeLenis.scrollTo(target);
  } else {
    target.scrollIntoView({ behavior: "smooth" });
  }

  if (!target.matches("a, button, input, select, textarea, [tabindex]")) {
    target.setAttribute("tabindex", "-1");
  }
  target.focus({ preventScroll: true });
});
